import { withTooltip } from '@crossnokaye/ux-common';

import { PRIVILEGES } from '@/hooks/access/access-table';
import { useActionPermission } from '@/hooks/use-action-permission';
import { Button } from '@/ux-common/components/button/button';
import { Stack } from '@/ux-common/components/stack/stack';

const ButtonWithTooltip = withTooltip(Button);

export const AddStageButton = ({ onClick }: { onClick: () => void }) => {
  const { isDisabled: disabledByPermissions, tooltipText } = useActionPermission({
    privilege: PRIVILEGES.writeCommands,
  });

  return (
    <ButtonWithTooltip
      delayDuration={0}
      disabled={disabledByPermissions}
      onClick={onClick}
      className="btn btn-xs"
      tooltipContent={
        <Stack className="stack-thin">
          <span className="font-bold">{'Add Stage'}</span>
          <span>{disabledByPermissions ? tooltipText : undefined}</span>
        </Stack>
      }
    >
      {'Add Stage'}
    </ButtonWithTooltip>
  );
};
